import basePath from "base_path";
import ActionTypes from "../constants/action_types";

import createReduxPromiseAction from "utils/create_redux_promise_action";

export default function removeContractType(requestor) {
  const action = createReduxPromiseAction(
    ActionTypes.CONTRACT_TYPE_REMOVE,
    (organisationId, contractTypeId, last_edited) => {
      return requestor
        .delete(
          `${basePath}/organisation/${organisationId}/contract_type/${contractTypeId}`,
          {
            data: {last_edited},
            withCredentials: true,
          },
        )
        .then(response => response.data)
        .catch(err => err.data);
    },
  );
  return action;
}
